const STATE_LABEL = {
  running: 'Running',
  completed: 'Completed',
  completed_with_failures: 'Finished with failures',
  interrupted: 'Interrupted — server restarted before it finished',
  failed: 'Stopped with an error',
};

const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '');

export const AiBatchProgress = ({ job }) => {
  if (!job) return null;
  const done = job.state === 'completed';
  const bar = job.state === 'running' ? 'bg-amber-500' : done ? 'bg-emerald-500' : 'bg-red-500';
  return (
    <div className="mt-3 space-y-1.5" data-testid="ai-batch-progress">
      <div className="flex items-center justify-between gap-3 flex-wrap text-xs">
        <span className="font-medium text-slate-800" data-testid="ai-batch-progress-count">
          {job.processed} / {job.eligible} processed
        </span>
        <span className="text-slate-600" data-testid="ai-batch-progress-outcome">
          <span className="text-emerald-700">{job.succeeded} succeeded</span>
          {' · '}
          <span className={job.failed ? 'text-red-700' : ''}>{job.failed} failed</span>
          {job.remaining > 0 && <> · {job.remaining} not yet processed</>}
        </span>
        <span className="text-slate-600" data-testid="ai-batch-progress-state">
          {STATE_LABEL[job.state] || job.state} · {job.percent}%
        </span>
      </div>
      <div className="h-1.5 w-full rounded bg-slate-200 overflow-hidden">
        <div className={`h-full ${bar} transition-[width] duration-500`} style={{ width: `${job.percent}%` }} />
      </div>
      <div className="text-[11px] text-slate-500 truncate" data-testid="ai-batch-progress-detail">
        {job.state === 'running' && job.current_item ? `Now: ${job.current_item} · ` : ''}
        Started {fmtTime(job.started_at)}
        {job.finished_at ? ` · ended ${fmtTime(job.finished_at)}` : ` · last update ${fmtTime(job.heartbeat_at)}`}
        {job.error ? ` · ${job.error}` : ''}
      </div>
    </div>
  );
};
